<template>
  <!-- 生产作业中心 -->
  <ModuleIndex></ModuleIndex>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>
</style>